import React, { useState } from "react";
import { TfiLayoutGrid3Alt } from "react-icons/tfi";
import { GiHamburgerMenu } from "react-icons/gi";
import { useSearchParams } from "react-router-dom";

const NavigationComponent = ({ handleItemClick, lefbarData }) => {
  const [isGrid, setIsGrid] = useState(true);

  const [searchParams] = useSearchParams();
  const option = searchParams.get("option");

  const toggleLayout = () => {
    setIsGrid(!isGrid);
  };

  const removeSpacesAndConvertToLower = (input) => {
    if (input?.length > 0) {
      return input.replace(/\s+/g, "")?.toLowerCase();
    }
  };

  return (
    <div>
      <div className="w-screen h-full px-4 ">
        <div className="w-full flex gap-3 mt-2 py-2">
          <div
            className={`w-8 h-8 border rounded ${
              isGrid ? "bg-[#C7EAC9]" : "bg-white"
            } bg-[#C7EAC9] flex justify-center items-center`}
            onClick={toggleLayout}
          >
            <TfiLayoutGrid3Alt size={20} />
          </div>
          <div
            className={`w-8 h-8 border rounded ${
              !isGrid ? "bg-[#C7EAC9]" : "bg-white"
            } bg-[#C7EAC9] flex justify-center items-center`}
            onClick={toggleLayout}
          >
            <GiHamburgerMenu size={23} />
          </div>
        </div>
        {isGrid ? (
          <div className="w-full flex flex-wrap justify-between gap-4">
            {lefbarData?.map((ele, i) => {
              return (
                <div
                  key={i}
                  className={`${
                    option === removeSpacesAndConvertToLower(ele?.label)
                      ? "bg-[#f2fbf3]"
                      : ""
                  } border w-[156px] h-[115px] gap-4 rounded-[5px] flex flex-col justify-center items-center`}
                  onClick={() => handleItemClick(ele)}
                  style={{ flex: "1 0 45%" }}
                >
                  <div className="w-5 h-5">
                    <img src={ele?.icon} className="w-full h-full" />
                  </div>
                  <div>
                    {" "}
                    <span>{ele.label}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="w-full mt-2">
            {lefbarData?.map((ele, i) => {
              return (
                <div
                  className="w-full flex h-[70px] items-center border-b gap-8"
                  onClick={() => handleItemClick(ele)}
                >
                  <div className="w-5 h-5">
                    <img src={ele?.icon} className="w-full h-full" />
                  </div>
                  <div>
                    {" "}
                    <span>{ele.label}</span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default NavigationComponent;
